
<template>
  <div style="padding:20px;background:#fff;border-radius:10px;">
    <exportDate v-if="showExport" @hideExport="hideExport1" :condition="condition" :provinCode="registProvcode" :provinceName="priviceName" :moduleName="moduleName"/>
    <div>
      <div class="top-div" style="overflow:hidden">
        <el-col :span="15">
            <span class="demonstration">{{priviceName}}各地区货运平台车辆运营吨位分布统计 - </span>
            <!--el-date-picker
              v-model="monTime"
              type="month"
              placeholder="选择月"
              @change="changeTime"
              value-format="yyyy-MM"
            ></el-date-picker-->
            <dimension-popover :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true" />
        </el-col>
        <el-col :span="9">
          <el-button style="float: right;margin-left: 10px;" v-show="hideExport" @click="exprotData">导出</el-button>
          <el-button style="float: right;" @click="goback" v-if="utype!=2">返回上一级</el-button>
          <el-select v-model="fuelType" @change="changeFuelType" style="width:150px;float: right;" placeholder="请选择燃油类型">
              <el-option
                v-for="(item,index) in fuelTypeList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
          </el-select>
        </el-col>
        </div>
        <div style="color:red;margin:10px 0">
          *数据统计口径见下方说明：
        </div>
         <el-table ref="singleTable"   :data="tableData" :max-height="tableHeight1" stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号 " align="center"></el-table-column>
        <el-table-column property="cityName" label="运营地区" align="center" width="150"></el-table-column>
        <el-table-column property="" label="统计维度" align="center"  width="150">
         <template slot-scope="scope">
            <div class="tabhgt" >
              车辆注册地区
            </div>
            <div class="tabhgt tabbor">
              车辆运营地区
            </div>
          </template>
        </el-table-column>
        <el-table-column property="totalCout" label="运营车辆数"   align="center">
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].totalCout:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].totalCout:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="first" align="center" label="10吨及以下运营车辆数">
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].first:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].first:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="second" label="10(含)-25吨运营车辆数" align="center">
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].second:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].second:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="three" label="25(含)-35吨运营车辆数"  align="center" >
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].three:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].three:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="four" label="35吨(含)以上运营车辆数"  align="center" >
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].four:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].four:0)}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <div class="bottom-top" >
      <h4><img src="../../../../assets/images/title.png"> <span>说明</span></h4>
      <div>1.车辆注册地区：该地注册入网重载货车在各统计周期内，在全国范围内的活跃车辆数，可反映该注册地区重载货车活跃度。</div>
        <div>2.车辆运营地区：全国各籍重载货车在某地（市/地区）范围内的运营车辆数，可反映该运营地区重载货车活跃度。【注】在统计时间内，1辆车在某地区运营，则在该地区计为1辆；在多地区运营，则在多地区分别计为1辆。因此存在各地区运营车辆数总和大于本省运营车辆数（去重）的情况。</div>
        <div>3.吨位划分：以车辆总质量的吨位数进行区间划分。</div>
        <div>4.统计频率：按月统计，每月6日更新上月数据。</div>
    </div>
  </div>
</template>
<script>
import http from '@/api/freight'
//import exportDate from '@/components/exportDate'
import exportDate from '@/components/exportDate/daphne/dialog.vue'
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
import { getFuelTypeList , getFuelTypeCode } from '@/utils/dictionary'
import get from 'lodash/get'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
let i = 0
// var now = new Date()
// now.setMonth(now.getMonth() - 1)
export default {
  components: {
    exportDate,
    dimensionPopover,
  },
  data() {
    let fuelTypeList = getFuelTypeList();
    return {
      fuelTypeList,
      hideExport:hideExport,
      i: 0,
      tableHeight1:this.tableHeight+150,
      showExport:false,
      monTime: '', // 默认月份
      moduleName:'vehicleCountCity',
      tableData: [],
      time:'',
      condition:"operator",
      utype:0
    }
  },
  props:{
     priviceName: {
      default: () => {
        return ''
      },
      type: String
    },
    registProvcode: {
      default: () => {
        return ''
      },
      type: String
    },
    value: {
      default: () => {
        return ''
      },
      type: String
    },
    fuelType: {
      default: () => {
        return ''
      },
      type: String
    },
    dimObj: {
      default: () => {
        return {
          year: "2022",
          month: "02",
          type: "0",
        }
      },
      type: Object
    },
  },
  watch: {
  },
  created() {
  },
  mounted(){
    this.utype = Cookies.get('userType')
    // this.time=this.utype!=2?this.value:"-"
    this.time=this.utype!=2?this.value:this.dimObj.year+'-'+this.dimObj.month
    this.monTime=this.value
    this.getDatails()

  },
  methods:{
    changeFuelType(){
      this.getDatails()
    },
    format(num) {
      if(num==null||num==undefined)return 0;
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
      // 取消导出
    hideExport1(){
      this.showExport=false
    },
    exprotData(){
      this.showExport=true
    },
    getDatails(){
      var that=this
      let energyType = getFuelTypeCode(this.fuelType);
      let type = get(this,"dimObj.type","0")
      that.tableData=[]
      var month=this.month
      if(month>9){
        month=this.month
      }else{
        month="0"+this.month
      }
       http
        .getCityDataList({
          provinCode:that.registProvcode,
          registMonth:that.time.split("-")[1],
          registYear:that.time.split("-")[0],
          condition:that.condition || "operator",
          energyType,
          type,
        })
        .then(e => {
          that.tableData=e.data&&e.data.tPageUtil
          let tt = e.data.time
          that.monTime = Number(tt.substr(0, 4))+'-'+Number(tt.substr(-2));
          that.month = Number(tt.substr(-2));
          that.year = Number(tt.substr(0, 4))
        })
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    changeDimension(e){
      if(e.isOk){
        this.monTime = e.year+"-"+e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      let that = this
      let time = that.monTime
      let arr = time.split('-')
      that.time = arr[0] + '-' + arr[1]
      that.getDatails()
    },
    goback(){
      this.$emit("closeDetails")
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1||columnIndex === 0) {
          if (rowIndex % 2 === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
    }
  }
}
</script>
<style >
.demonstration{
  font-weight: bold
}
.tabhgt{
  height: 40px;
  line-height: 35px;
}
.tabbor{
  border-top: 1px solid #ebeef5;
  line-height: 50px;
}
.el-table td .cell{
  padding-right: 0 !important;
  padding-left: 0 !important;
}
</style>
